module.exports = __webpack_public_path__ + "static/media/packing-unpacking.541cd7ed.png";